import { render, staticRenderFns } from "./ossUpload.vue?vue&type=template&id=4962f64e&scoped=true"
import script from "./ossUpload.vue?vue&type=script&lang=js"
export * from "./ossUpload.vue?vue&type=script&lang=js"
import style0 from "./ossUpload.vue?vue&type=style&index=0&id=4962f64e&prod&lang=css"
import style1 from "./ossUpload.vue?vue&type=style&index=1&id=4962f64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962f64e",
  null
  
)

export default component.exports